import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import _toString from 'lodash/toString';
import _isFunction from 'lodash/isFunction';
import PropTypes from 'prop-types';
// Core components
import Select from 'components/core/Select';
// Custom
import AppIcon from 'components/icons/AppIcon';

const ResourceIcon = ({ itemIcon, itemCustomIcon }) => {
  if (itemIcon) {
    return (
      <AppIcon defaultColor id={itemIcon} />
    );
  }
  if (itemCustomIcon) {
    return itemCustomIcon;
  }
  return null;
};

ResourceIcon.propTypes = {
  itemIcon: PropTypes.string,
  itemCustomIcon: PropTypes.node,
};

ResourceIcon.defaultProps = {
  itemIcon: null,
  itemCustomIcon: null,
};

const ResourcesSelectField = ({
  labelId,
  value,
  resources,
  displayKey,
  withNullItem,
  nullItemLabel,
  errorText,
  readOnly,
  margin,
  onChange,
  ...otherProps
}) => {
  if (resources) {
    return (
      <Select
        label={labelId && <LocalizedMessage id={labelId} />}
        value={value}
        items={
          _map(resources, (resource) => ({
            key: _toString(resource.id),
            divider: resource.divider,
            header: resource.header,
            value: resource.id,
            label: _isFunction(displayKey) ? displayKey(resource) : resource[displayKey],
            icon: ResourceIcon(resource),
          }))
        }
        withNullItem={withNullItem}
        nullItemLabel={nullItemLabel}
        errorText={errorText}
        readOnly={readOnly}
        margin={margin}
        onChange={onChange}
        {...otherProps}
      />
    );
  }
  return null;
};

ResourcesSelectField.propTypes = {
  labelId: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  resources: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    }),
  ),
  displayKey: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).isRequired,
  withNullItem: PropTypes.bool,
  nullItemLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  errorText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  readOnly: PropTypes.bool,
  margin: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

ResourcesSelectField.defaultProps = {
  labelId: null,
  value: null,
  // This may be null due to initial loading
  resources: null,
  withNullItem: false,
  nullItemLabel: null,
  errorText: null,
  readOnly: false,
  margin: 'normal',
};

module.exports = ResourcesSelectField;



// WEBPACK FOOTER //
// ./components/inputFields/ResourcesSelectField.js